import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CompanySearch from '../CompanySearch';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';
import InsightsView from './InsightsView';
import { apiGet } from '../../utils/api';
import { useDataFetch } from '../../hooks/useApi';
import '../SalaryManagement.css';

// 상단 메뉴 '기업 인사이트': 기업을 고르면 그 기업의 인력·인건비 흐름과 챙겨야 할 일, 직원별 변화를 본다.
// 달·줄을 누르면 임금대장 화면의 그 달 그 줄로 간다.
function CompanyInsights() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [sidebarFolded, setSidebarFolded] = useState(false);
  const { data: companies, loading, error } = useDataFetch(() => apiGet('/api/companies/'), []);
  const { data: users } = useDataFetch(() => apiGet('/api/companies/users/list'), []);
  const companyId = searchParams.get('company');
  const company = useMemo(
    () => (companies || []).find((c) => String(c.id) === String(companyId)) || null,
    [companies, companyId],
  );

  if (loading) return <div className="salary-management"><LoadingSpinner message="데이터를 불러오는 중..." /></div>;
  if (error) return <div className="salary-management"><ErrorMessage message={error} type="error" /></div>;

  const openRow = (place) => {
    const query = new URLSearchParams({ company: company.id, year: place.year, month: place.month, row: place.row_id, sheet: place.sheet });
    navigate(`/payroll?${query}`);
  };

  return (
    <div className="salary-management">
      <div className="salary-layout">
        <aside className={`company-sidebar ${sidebarFolded ? 'folded' : ''}`}>
          <div className="sidebar-content">
            <CompanySearch
              companies={companies || []}
              onCompanySelect={(c) => setSearchParams(c ? { company: c.id } : {})}
              selectedCompany={company}
              onAddCompany={() => navigate('/payroll')}
              onEditCompany={() => {}}
              users={users || []}
            />
          </div>
          <button
            type="button"
            className="sidebar-fold-toggle"
            onClick={() => setSidebarFolded(!sidebarFolded)}
            title={sidebarFolded ? '기업 검색 펼치기' : '기업 검색 접기'}
          >
            <span className="sidebar-fold-icon">{sidebarFolded ? '›' : '‹'}</span>
          </button>
          {sidebarFolded && <span className="sidebar-fold-label">기업검색</span>}
        </aside>

        <main className="salary-content ins-page">
          {company ? (
            <>
              <div className="ins-page-head">
                <h2>{company.name} <span className="ins-title">기업 인사이트</span></h2>
                <span className="ins-muted">임금대장에 쌓인 값으로 만든 인력·인건비 흐름입니다. 계약 변경은 달마다 저장된 계약 값을 직전 달과 비교한 것입니다.</span>
              </div>
              <InsightsView key={company.id} companyId={company.id} onOpenRow={openRow} />
            </>
          ) : (
            <div className="no-selection">
              <div className="no-selection-content">
                <div className="no-selection-icon">📈</div>
                <h3>기업 인사이트</h3>
                <p>왼쪽에서 기업을 선택하세요</p>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default CompanyInsights;
